import { useState } from "react";
import Aos from "aos";
import { useEffect } from "react";

const BankvoleContact = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = ({ target: { name, value } }) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: wire up to your form/email service
  };
  useEffect(() => {
        Aos.init({
            duration: 1000,
        });
    }, []);

  return (
    <section className="bv-contact">
      <div className="bv-contact-left" data-aos="fade-up">
        <h2 className="bv-contact-title">Contact Us</h2>
        <p className="bv-contact-text">
          Questions, complaints, or suggestions? Send us a message or simply
          fill in the form and we&apos;ll be in touch shortly.
        </p>
        <div className="bv-contact-info">
          <p>
            <span className="bv-contact-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.5.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.7 21 3 13.3 3 4c0-.6.4-1 1-1h3.4c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.5.1.4 0 .8-.2 1L6.6 10.8z"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            +234 707 480 6182
          </p>
          <p>
            <span className="bv-contact-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect
                  x="3"
                  y="5"
                  width="18"
                  height="14"
                  rx="2"
                  stroke="currentColor"
                  strokeWidth="1.6"
                />
                <path
                  d="M4 7l8 6 8-6"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
           bankvole@checkoff.finance
          </p>
        </div>
      </div>

      <div className="bv-contact-right" data-aos="zoom-in">
        <form className="bv-contact-form" onSubmit={handleSubmit}>
          <div className="bv-contact-form-row">
            <input
              className="form-control shadow-none"
              name="firstName"
              placeholder="First Name"
              value={form.firstName}
              onChange={handleChange}
            />
            <input
              className="form-control shadow-none"
              name="lastName"
              placeholder="Last Name*"
              value={form.lastName}
              onChange={handleChange}
              required
            />
          </div>
          <input
            className="form-control shadow-none"
            name="email"
            type="email"
            placeholder="Email*"
            value={form.email}
            onChange={handleChange}
            required
          />
          <input
            className="form-control shadow-none"
            name="phone"
            type="tel"
            placeholder="Phone Number*"
            value={form.phone}
            onChange={handleChange}
            required
          />
          <textarea
            className="form-control shadow-none"
            name="message"
            placeholder="Your message..."
            rows="6"
            value={form.message}
            onChange={handleChange}
          ></textarea>
          <button type="submit" className="btn btn-primary shadow-none bv-contact-submit">
            Send
          </button>
        </form>
      </div>
    </section>
  );
};

export default BankvoleContact;
